
import moment from "moment-timezone";

export const dateFormat: (rawDate: string | number | null) => string = (
    rawDate: string | number | null = null,
) => {
   if (rawDate === null || rawDate === 'null') return '-'
   const tz = 'Africa/Kampala';
   if (typeof rawDate === 'string') {
      return moment.utc(rawDate).tz(tz).format('DD-MM-YYYY')
   }
   return moment.utc(moment.unix(rawDate)).tz(tz).format('DD-MM-YYYY')
}

export function sqlDateFormat(date:string|null) {
   if(date == null || date == ""){
      return "--"
   }
   return moment(date).tz('Africa/Kampala').format("YYYY-MM-DD");
}

export function dateTimeFormat(date:string) {
   if(date == null || date == ""){
      return "--"
   }
   //let tz = profile.value?.profile.timezone ?? "Africa/Kampala"
   //const tzDate = moment.tz(date, tz)
   return moment.utc(date).tz('Africa/Kampala').format("DD-MM-YYYY HH:mm:ss");
}

export function formatReadableDate(dateString: string): string {
    // 1. Parse the input string into a Date object.
    // Replace the space with 'T' to ensure correct UTC/local time parsing across browsers.
    const date = new Date(dateString.replace(' ', 'T'));

    // Check if the date is valid before proceeding
    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }

    // 2. Define formatting options
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',   // e.g., 2025
        month: 'long',     // e.g., October
        day: 'numeric',    // e.g., 14
        // You can add time roles if needed, e.g., hour: '2-digit'
    };

    // 3. Format the date using a specific locale (e.g., 'en-US')
    // The structure will naturally be Day Month Year (e.g., 14 October 2025)
    return new Intl.DateTimeFormat('en-UK', options).format(date);
}

export function cleanUnderscores(text:string){
   if(text == null){
      return ""
   }
   return text.replace(/[\s_-]+/g, " ")
}

export function removeCountryCode(phone:string|null){
   if(phone == "" || phone == undefined){
      return null
   }
   let length = phone.length
   return phone.substring(3, length)
}

export function timeLapse(date:string) {
   if(date == null){
      return "--"
   }

   let formattedDate = moment(date).format("DD-MM-YYYY HH:mm:ss");
   let startDate = moment(formattedDate, "DD-MM-YYYY HH:mm:ss")

   let elapsedDuration = moment.duration(moment().diff(startDate));

   let duration = 0
   let lapse = ""

   if(elapsedDuration.asSeconds() < 60){
      duration = Math.floor(elapsedDuration.asSeconds())
      lapse = (duration >  1) ? " secs ago" :" sec ago"

      return duration + lapse
   }
   if(elapsedDuration.asMinutes() < 60){
      duration = Math.floor(elapsedDuration.asMinutes())
      lapse = (duration >  1) ? " mins ago" : " min ago"

      return duration + lapse
   }

   if(elapsedDuration.asHours() < 24){
      duration = Math.floor(elapsedDuration.asHours())
      lapse = (duration >  1) ? " hrs ago" : " hr ago"

      return duration + lapse
   }

   if(elapsedDuration.asDays() > 1 && elapsedDuration.asDays() < 7){
      duration = Math.floor(elapsedDuration.asDays())
      lapse =  (duration >  1) ? " days ago" : " day ago"

      return duration + lapse
   }

   if(elapsedDuration.asWeeks() > 0 && elapsedDuration.asWeeks() < 4){
      duration = Math.floor(elapsedDuration.asWeeks())
      lapse =  (duration >  1) ? " weeks ago" : " week ago"

      return duration + lapse
   }

   return formattedDate
}

export function duration(date1:any, date2:any) {
    console.log(date1)
    console.log(date2)
   if(date1 == null){
      return "0 days"
   }

   if(date2 == null){
      date2 = moment.now()
   }

   let formattedDate1 = moment(date1).format("DD-MM-YYYY");
   let formattedDate2 = moment(date2).format("DD-MM-YYYY");
   let startDate = moment(formattedDate1, "DD-MM-YYYY");
   let endDate = moment(formattedDate2, "DD-MM-YYYY");
   return endDate.diff(startDate, 'days') + " days"
}

export function countdown(date:any):number {
    const date1 = moment.now()

    let formattedDate1 = moment(date1).format("DD-MM-YYYY");
    let formattedDate2 = moment(date).format("DD-MM-YYYY");
    let startDate = moment(formattedDate1, "DD-MM-YYYY");
    let endDate = moment(formattedDate2, "DD-MM-YYYY");
    return endDate.diff(startDate, 'days')
}

export function percentage(numerator:number|undefined, denominator:number|undefined) {
   if(numerator == null || denominator == null){
      return 0;
   }
   return ((numerator/denominator) * 100).toFixed(2);
}

export function cleanUnderscoreString(word:string){
    if(word) return word.replace(/_/g, " ");
    else return "";
}